import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setAreas } from '../../../store/settingGroupStore/settingGroupStoreAreaListSlice';
import settingGroupStoreGetAreaListApi from '../../../apis/settingGroupStore/settingGroupStoreGetAreaListApi';
import { useLoading } from '../../../hooks';

// キャッシュチェック用
export const TODAY = new Date().getDate();

// リクエスト制御
let isRequesting = false;

export function useStoreGroupsSettingsAreas() {
  const dispatch = useDispatch();

  // 【settingGroupStore008】エリアリスト取得
  // { areaCode: number, areaName: string, wishCityCount: number }
  // TODO: 毎回リロードの際、データを更新したい場合、Reduxを使用ください
  const { areaList } = useSelector((s) => s.settingGroupStoreAreas);

  const { addLoading, removeLoading } = useLoading();

  /**
   * 【settingGroupStore008】エリアリスト取得
   */
  const getAreaList = useCallback(async () => {
    if (isRequesting) return;
    isRequesting = true;
    addLoading();
    try {
      const res = await settingGroupStoreGetAreaListApi();
      const { areas = [] } = res.data;
      const srotedArea = areas.sort((a, b) => (a.areaCode - b.areaCode > 0 ? 1 : -1));
      dispatch(setAreas(srotedArea));
    } finally {
      removeLoading();
      isRequesting = false;
    }
  }, []);

  // 初期化
  useEffect(() => { getAreaList(); }, []);

  return {
    areaList,
    getAreaList,
  };
}
